/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageLoadSeriesDto } from '../../models/usage-load-series-dto';

export interface GetUsageLoadSeries$Params {
  from?: string;
  to?: string;
  minutes?: number;
  'X-API-Version'?: string;
}

export function getUsageLoadSeries(http: HttpClient, rootUrl: string, params?: GetUsageLoadSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageLoadSeriesDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageLoadSeries.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('minutes', params.minutes, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageLoadSeriesDto>;
    })
  );
}

getUsageLoadSeries.PATH = '/api/usage-statistics/load/series';
